// extracted by mini-css-extract-plugin
module.exports = {"root":"showreel-module--root--3tBye","marquee":"showreel-module--marquee--1tmZD"};